import request from "@/utils/request";

//项列表分页
export const getProjectList = (data) => {
	return request({
		url: "/index/project/list",
		method: "post",
		data
	});
};

//修改评分标准表
export const updateScore = (data) => {
	return request({
		url: "/eduScoringCriteria/update",
		method: "post",
		data
	});
};

//项列表分页
export const getProjectList1 = (data) => {
	return request({
		url: "/index/project/list1",
		method: "post",
		data
	});
};

//发布提交通知
export const addReview = (data) => {
	return request({
		url: "/api/review/add",
		method: "post",
		data
	});
};

// 根据id获取项目详情
export const getReviewInfo = (id) => {
	return request({
		url: `/index/project/list/${id}`,
		method: "get",
	});
};

export const saveOrUpdateExpertsScoreUp2 = (id) => {
	return request({
		url: `/api/eduExpertsScore/saveOrUpdateExpertsScoreUp2/${id}`,
		method: "get",
	});
};

// 统计
export const apiEduReviewStick = (id, projectId) => {
	return request({
		url: `/api/review/apiEduReviewStick/${id}/${projectId}`,
		method: "get",
	});
};

export const ExpertsScoreUp = (id) => {
	return request({
		url: `/api/eduExpertsScore/saveOrUpdateExpertsScoreUp1/${id}`,
		method: "get",
	});
};

// 征文详情
export const getApiReview = (id) => {
	return request({
		url: `/api/review/info1/${id}`,
		method: "get",
	});
};

// 征文详情
export const getApiReviewInfo = (id) => {
	return request({
		url: `/api/review/info/${id}`,
		method: "get",
	});
};

// 征文分页列表
export const getPageListReview = (data) => {
	return request({
		url: '/api/review/getPageList',
		method: "post",
		data
	});
};

// 根据当前登录人获取负责的课题列表
export const getTopicInChargeList = (data) => {
	return request({
		url: '/api/eduProjectManagement/topicInChargeList',
		method: "post",
		data
	});
};

// 根据当前登录人获取专家评分列表
export const getExpertsScoreList = (data) => {
	return request({
		url: '/api/eduManagementExpertsScore/expertsScoreList',
		method: "post",
		data
	});
};

// 基本设置信息添加
export const saveBasicInfo = (data) => {
	return request({
		url: '/api/eduExpertsSubjectSettings/saveBasicInfo',
		method: "post",
		data
	});
};

// 添加或编辑课题项目表
export const saveOrUpdate = (data) => {
	return request({
		url: '/api/eduProject/saveOrUpdate',
		method: "post",
		data
	});
};

// 平台信息数据数结构
export const getEduDictData = (id) => {
	return request({
		url: `/api/eduDictData/tree/${id}`,
		method: "get",
	});
};

// 删除项目
export const delEduProject = (id) => {
	return request({
		url: `/api/eduProject/del/${id}`,
		method: "get",
	});
};

// 删除设置
export const delProjectById = (id) => {
	return request({
		url: `/api/projectManagementSetting/del/${id}`,
		method: "delete"
	});
};

// 批量审核
export const batchUpdate = (data) => {
	return request({
		url: '/api/review/batchUpdate',
		method: "post",
		data
	});
};

// 添加评审组
export const addSettingGroup = (data) => {
	return request({
		url: '/api/eduProject/addSettingGroup',
		method: "post",
		data
	});
};

// 获取评审组
export const settingGroup = (id) => {
	return request({
		url: `/api/eduProject/settingGroup/${id}`,
		method: "get",
	});
};

// 删除评审组
export const delSettingGroup = (id) => {
	return request({
		url: `/api/eduProject/settingGroupDel/${id}`,
		method: "get",
	});
};

// 系统用户分页列表
export const userGetPageList = (data) => {
	return request({
		url: '/api/user/getPageList',
		method: "post",
		data
	});
};

// 评分标准表分页列表
export const getEduScoringCriteria = (data) => {
	return request({
		url: '/eduScoringCriteria/getPageList',
		method: "post",
		data
	});
};

// 添加评分标准表
export const addEduScoringCriteria = (data) => {
	return request({
		url: '/eduScoringCriteria/add',
		method: "post",
		data
	});
};

// 删除评分标准表
export const delEduScoringCriteria = (data) => {
	return request({
		url: `/eduScoringCriteria/delete/${data.id}`,
		method: "post",
		data
	});
};

// 根据设置Id查看评审进度
export const reviewProgressList1 = (data) => {
	return request({
		url: '/api/eduExpertsSubjectSettings/reviewProgressList1',
		method: "post",
		data
	});
};

// 根据设置Id查看评审进度
export const reviewProgressList = (data) => {
	return request({
		url: '/api/projectManagementSetting/reviewProgressList',
		method: "post",
		data
	});
};

// 修改征文
export const updateReview = (data) => {
	return request({
		url: '/api/review/update',
		method: "post",
		data
	});
};

// 根据设置Id和评审专家id查看评审进度详情
export const reviewProgressInfo = (data) => {
	return request({
		url: `/api/projectManagementSetting/reviewProgressInfo/${data.userId}/${data.settingId}`,
		method: "get",
	});
};
// 根据设置Id和评审专家id查看评审进度详情
export const reviewProgressInfo1 = (data) => {
	return request({
		url: '/api/projectManagementSetting/reviewProgressInfo1',
		// url: `/api/projectManagementSetting/reviewProgressInfo1/${data.userId}/${data.settingId}`,
		method: "post",
		data
	});
};


// 删除征文
export const delReview = (id) => {
	return request({
		url: `/api/review/delete/${id}`,
		method: "post",
	});
};

// 结束征文
export const endEduProject = (data) => {
	return request({
		url: '/api/eduProject/end',
		method: "post",
		data
	});
};

// 专家评分表 => 提交
export const saveOrUpdateExpertsScoreUp = (id) => {
	return request({
		url: `/api/eduExpertsScore/saveOrUpdateExpertsScoreUp/${id}`,
		method: "get",
	});
};

// 添加课题关联校审或学段审查
export const schoolAudit = (data) => {
	return request({
		url: '/eduSubjectDeclareSchoolAudit/add',
		method: "post",
		data
	});
};

// 修改评分
export const saveExpertsScoreUp = (data) => {
	return request({
		url: '/api/eduExpertsScore/saveExpertsScoreUp',
		method: "post",
		data
	});
};

// 修改评分
export const saveExpertsScoreUp1 = (data) => {
	return request({
		url: '/api/eduExpertsScore/saveExpertsScoreUp1',
		method: "post",
		data
	});
};

// 验证超出次数
export const exceedReview = (data) => {
	return request({
		url: '/api/review/exceed',
		method: "post",
		data
	});
};

// 专家评审设置课题分组项目详情1
export const getInfo1 = (id) => {
	return request({
		url: `/eduExpertsSubjectGroup/info1/${id}`,
		method: "get",
	});
};

// 按数量统计
export const apiEduReviewStick1 = (type) => {
	return request({
		url: `/api/review/apiEduReviewStick1/${type}`,
		method: "get",
	});
};

// 按学段统计
export const apiEduReviewStick2 = (type) => {
	return request({
		url: `/api/review/apiEduReviewStick2/${type}`,
		method: "get",
	});
};

// 导出选中征文附件
export const exportReivewReport = (ids) => {
	return request({
		url: `/api/projectManagementAudit/exportReivewReport/${ids}`,
		method: "get",
		responseType: 'blob',
	});
};

// 更新
export const updateFile = (data) => {
	return request({
		url: `/api/projectManagementSetting/uploadScoringCriteriaAnnex1/${data.settingId}/${data.reviewId}`,
		method: "get",
	});
};

// 获取评分附件
export const getEduFile = (ids) => {
	return request({
		url: `/api/eduProject/info/${ids}`,
		method: "get",
	});
};